import {
    setAIVoiceFiltersRequestFailed,
    setAIVoiceFiltersRequestStarted,
    setAIVoiceFiltersRequestSucceeded,
    setAttributes,
} from './ai-voice-filters-slice';

import { AIVoiceFilterTypeEnum, ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';
import uuid from 'js/src/libs/uuid';

export const fetchAIVoiceFiltersByFilterType = (filterType: AIVoiceFilterTypeEnum) => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceFilterList({
                query: { [filterType]: true },
            });
            dispatch(setAttributes({ filterType, data: response.data }));
        } catch (error) {
            ErrorReporter.capture(error);
            // Rethrow so callers fetching several filter types together can tell that
            // this one failed. Swallowing it here left fetchAIVoicePublicFilters
            // reporting success for a request that returned no filters at all.
            throw error;
        }
    };
};

export const fetchAIVoicePublicFilters = () => {
    return async (dispatch: AppDispatch) => {
        const requestId = uuid();
        dispatch(setAIVoiceFiltersRequestStarted(requestId));
        const filterTypes: AIVoiceFilterTypeEnum[] = [
            AIVoiceFilterTypeEnum.ACCENT,
            AIVoiceFilterTypeEnum.AGE,
            AIVoiceFilterTypeEnum.GENDER,
            AIVoiceFilterTypeEnum.LANGUAGE,
            AIVoiceFilterTypeEnum.STYLE,
            AIVoiceFilterTypeEnum.TONE,
        ];
        const results = await Promise.allSettled(
            filterTypes.map((filterType) => dispatch(fetchAIVoiceFiltersByFilterType(filterType))),
        );
        const rejected = results.filter((result) => result.status === 'rejected');
        if (rejected.length > 0) {
            dispatch(
                setAIVoiceFiltersRequestFailed({
                    requestId,
                    error: `Failed to load ${rejected.length} of ${filterTypes.length} AI voice filter types`,
                }),
            );
            return;
        }
        dispatch(setAIVoiceFiltersRequestSucceeded({ requestId }));
    };
};
